import {useRef, useState} from "react";

import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import ProjectRoutes from "../../../pages/projects/projectRoutes/projectRoutes";

import SectionContent from "../../../components/sectionContent/sectionContent";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import HeaderBtn from "../../../components/headerBtn/headerBtn";

const ProjectRoutesSection = () => {
    const { id } = useParams<{ id: any }>();
    const { data } = useSelector((state: any) => state.projects.projects);
    const { claims } = useSelector((state: any) => state.user.user.data);

    const buttonsContainerRef = useRef<any>(null);

    const [overflowedBtnsCount] = useState<number>(0);
    const [isOpenGroupBtn] = useState(false);

    const availableButtons = [
        {
            component: (
                <HeaderBtn
                    content="Настройки"
                    purpose="routesSettings"
                    modalTitle="Настройки"
                />
            ),
        },
        (claims.includes('admin') || claims.includes('recruiting:vacancy:edit')) && {
            component: (
                <HeaderBtn
                    content="Создать вакансию"
                    purpose="createVacancyRoutes"
                    modalTitle="Создать вакансию"
                />
            ),
        },
    ]

    const filteredAvailableButtons = availableButtons.filter((btn: any) => btn);

    const displayedAvailableBtns = filteredAvailableButtons
        ?.slice(-(overflowedBtnsCount as number))
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });

    const displayedHeadBtns = filteredAvailableButtons
        ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
        ?.map((elem: any, index: any) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });


    const currentPageTitle = data && data.find( (el: any) => el?.project?.id === parseFloat(id as string))?.project?.name

    return (
        <div className="App">
            <Sidebar />
            <SectionContent
                availableButtons={displayedAvailableBtns}
                title={currentPageTitle && currentPageTitle}
                buttonsContainerRef={buttonsContainerRef}
                headBlockChildren={displayedHeadBtns}
                isOpenGroupBtn={isOpenGroupBtn}
                pageName="projectMerchRoutes"
                section="Проекты"
            >
                <div className="content__main">
                    <div className="btns">
                        <Link to={`/projects/${id}/info`} className="tab">
                            <div className="buttons__btn">Информация</div>
                        </Link>
                        <Link to={`/projects/${id}/routes`} className="tab">
                            <div className="buttons__btn --active">Маршруты</div>
                        </Link>
                        {(claims.includes('admin') || claims.includes('recruiting:vacancy:view')) &&
                        <Link
								to={`/projects/${id}/vacancy`}
								className='tab'
							>
								<div className='buttons__btn'>Вакансии</div>
						</Link>}
                    </div>
                    <ProjectRoutes id={id}/>
                </div>
            </SectionContent>
        </div>
    )
}

export default ProjectRoutesSection
